import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { History } from "lucide-react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { OptimizeExperienceModal } from "@/components/stealth-writer/OptimizeExperienceModal";
import { userPlanQueryOptions } from "@/lib/queries/payment/userPlan";
import { UpgradePlanModal } from "@/components/stealth-writer/UpgradePlanModal";
import { ReachedLimitModal } from "@/components/stealth-writer/ReachedLimitModal";

export const Route = createFileRoute("/_app/stealth-ai-writer/")({
  component: RouteComponent,
  async loader({ context: { queryClient } }) {
    await queryClient.prefetchQuery(userPlanQueryOptions);
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const plan = useSuspenseQuery(userPlanQueryOptions);
  const forUpgradePlan = ["Free Plan", "Standard Plan"];

  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showLimitModal, setShowLimitModal] = useState(false);

  // TODO: clean this up
  const handleClickStart = () => {
    if (forUpgradePlan.includes(plan.data.info?.plan.name ?? "")) {
      // show upgrade modal
      setShowUpgradeModal(true);
      return;
    } else if (plan.data.info?.plan.features.services.AI_WRITER == 0) {
      // show reached limit modal
      setShowLimitModal(true);
      return;
    } else {
      navigate({ to: "/stealth-ai-writer/generate-article" });
    }
  };

  return (
    <div className="flex min-h-[calc(100vh-8rem)] w-full flex-col rounded-xl border bg-white p-4 text-black dark:bg-black dark:text-white">
      <OptimizeExperienceModal />
      <UpgradePlanModal
        open={showUpgradeModal}
        onOpenChange={setShowUpgradeModal}
      />
      <ReachedLimitModal
        open={showLimitModal}
        onOpenChange={setShowLimitModal}
      />
      <div className="h-[100%] w-full overflow-hidden border-gray-200 p-6 dark:border-gray-800">
        <header className="mb-20 flex w-full items-center justify-between">
          <div>
            <h1 className="text-xl font-medium">Stealth AI</h1>
            <p className="text-sm text-muted-foreground">
              Create or enhance content with real-time AI.
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="dark:bg-gray-800/30"
            onClick={() => {
              navigate({
                to: "/history",
                search: { selectedServices: ["AI_WRITER"] },
              });
            }}
          >
            <History className="size-4" />
            Content History
          </Button>
        </header>

        <main className="flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center gap-8">
            <div className="relative">
              <div className="absolute -z-10 size-20 rounded-full bg-pink-100 blur-md dark:bg-gray-900/30" />
              <img
                src="/icons/stealth.svg"
                alt="Stealth AI Logo"
                className="relative z-10 h-auto w-50"
              />
            </div>

            <div className="flex flex-col items-center justify-center text-center">
              <h2 className="mb-1 text-xl font-medium">Stealth AI</h2>
              <p className="text-sm text-muted-foreground">
                Create or enhance content with real-time AI.
              </p>
            </div>

            <Button
              className="w-64 bg-gray-700 hover:bg-gray-600 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600"
              onClick={handleClickStart}
            >
              Start New
            </Button>
          </div>
        </main>
      </div>
    </div>
  );
}
